import { Layout as LayoutAnt } from 'antd';
import { env } from '../services/utils';
const { Footer } = LayoutAnt;

export default function FooterCustom() {
    return (
        <Footer style={{ textAlign: 'center' }}>Business Management System{ env.DEV ? ' - DEV' : '' }</Footer>
    )
}